import Swiper from "swiper";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { EffectFade, Pagination, Navigation, Autoplay } from "swiper/modules";

(function initTopFvSlider() {
  const root = document.querySelector(".p-top-fv .p-top-fv__content");
  const list = root?.querySelector(".p-top-fv__list");
  if (!root || !list) return;

  const items = Array.from(list.children).filter((el) =>
    el.classList.contains("p-top-fv__item")
  );
  if (items.length < 2) return;

  if (root.dataset.swiperInited === "1") return;
  root.dataset.swiperInited = "1";

  root.classList.add("swiper");
  list.classList.add("swiper-wrapper");
  items.forEach((li) => li.classList.add("swiper-slide"));

  const paginationEl = document.createElement("div");
  paginationEl.className = "p-top-fv__pagination swiper-pagination";
  const prevEl = document.createElement("button");
  prevEl.type = "button";
  prevEl.className = "p-top-fv__prev swiper-button-prev";
  prevEl.setAttribute("aria-label", "前のスライド");
  const nextEl = document.createElement("button");
  nextEl.type = "button";
  nextEl.className = "p-top-fv__next swiper-button-next";
  nextEl.setAttribute("aria-label", "次のスライド");

  const uiWrap = document.createElement("div");
  uiWrap.className = "p-top-fv__ui";

  const navRow = document.createElement("div");
  navRow.className = "p-top-fv__nav";

  navRow.append(prevEl, nextEl);
  uiWrap.append(paginationEl, navRow);
  root.appendChild(uiWrap);

  const swiper = new Swiper(root, {
    modules: [EffectFade, Pagination, Navigation, Autoplay],
    effect: "fade",
    fadeEffect: { crossFade: true },
    speed: 1000,
    loop: items.length >= 2,
    allowTouchMove: true,
    observer: true,
    observeParents: true,
    pagination: {
      el: paginationEl,
      clickable: true,
    },
    navigation: {
      prevEl,
      nextEl,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: false, 
    },
    on: {
      afterInit(sw) {
        requestAnimationFrame(() => {
          sw.update();

          const replaceArrowIcon = (btn) => {
            if (!btn) return;
            btn
              .querySelectorAll("svg.swiper-navigation-icon")
              .forEach((el) => el.remove());
            if (!btn.querySelector("span")) {
              const span = document.createElement("span");
              span.className = "p-top-fv__arrow-icon";
              btn.appendChild(span);
            }
          };

          replaceArrowIcon(sw.navigation?.nextEl);
          replaceArrowIcon(sw.navigation?.prevEl);
        });
      },
    },
  });

  const imgs = list.querySelectorAll("img");
  imgs.forEach((img) => {
    img.addEventListener("load", () => swiper.update(), { once: true });
  });
})();
